export default __webpack_public_path__ + "static/media/insta3.ea5d5277.png";